import { render, staticRenderFns } from "./Formulario.vue?vue&type=template&id=544de67f&scoped=true"
import script from "./Formulario.vue?vue&type=script&lang=js"
export * from "./Formulario.vue?vue&type=script&lang=js"
import style0 from "./Formulario.vue?vue&type=style&index=0&id=544de67f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544de67f",
  null
  
)

export default component.exports